interface GuideProgressProps {
  current: number;
  total: number;
  category?: string;
}

export default function GuideProgress({ current, total, category }: GuideProgressProps) {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-label2 text-label-assistive">{current} / {total}</span>
        {category && (
          <span className="inline-block px-2 py-0.5 rounded-full bg-fill-normal text-accent-brown text-caption font-medium">
            {category}
          </span>
        )}
      </div>
      <div className="w-full h-1.5 rounded-full bg-fill-strong overflow-hidden">
        <div
          className="h-full rounded-full bg-primary-normal transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}